import { FC } from "react";
import { InactiveMark } from "theme/icons";

import { Avatar as MuiAvatar } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledImage = styled(MuiAvatar)(() => {
  return {
    width: 88,
    height: 88,
  };
});

type ImageProps = {
  src: string;
};

const Image: FC<ImageProps> = ({ src }) => {
  return (
    <StyledImage variant="square" src={src ?? undefined}>
      <InactiveMark />
    </StyledImage>
  );
};

export default Image;
